import App from '@gral/app';
import mqttService from '../../../services/mqtt/mqttService';
import actServer from '@flux/actions/actServer';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { useAppDispatch } from '@redux/store';

// Función para suscribirse al MQTT
export const mqttSubscribe = (subTopic, callback) => {
  const cxStore = App.cxStore;
  const organizationId = cxStore.getOrganizationId();
  const credentials = cxStore.getMqttCredentials();
  if (!credentials) return;

  const client = mqttService.getClient(credentials);

  const topic = `/1/${organizationId}/item/#`;
  mqttService.subscribe(client, topic, subTopic, callback);
};

// Función para desuscribirse del MQTT y cerrar la conexión
export const mqttUnsubscribe = subTopic => {
  const cxStore = App.cxStore;
  const organizationId = cxStore.getOrganizationId();
  const credentials = cxStore.getMqttCredentials();
  if (!credentials) return;

  const client = mqttService.getClient(credentials);
  const topic = `/1/${organizationId}/item/#`;

  mqttService.unsubscribe(client, topic, subTopic);
};
